<template>
    <div>
        <b-checkbox v-for="(def, key) in defaultBulkEdit" :key="key" v-model="selected" :value="key">Change {{ key }} to {{ def }}</b-checkbox>
        <!-- {{ selected }} -->
    </div>
</template>

<script>
    export default {
        name: "BulkEdit",
        props: [ 'items', 'defaults' ],
        data() {
            return {
                selected: [],
            }
        },
        computed: {
            defaultBulkEdit() {
                return {
                    location: this.defaults.location,
                    source: this.defaults.source,
                    offsite: this.defaults.offsite
                };
            }
        },
        watch: {
            selected() {
                this.$emit('bulkEditSelected', this.selected);
            }
        }
    }
</script>

<style scoped>

</style>